import React from 'react';
import { Tag, Tooltip } from 'antd';
import { formatCurrency, formatBothCurrencies } from '../../utils/currency';

/**
 * CurrencyDisplay Component
 * Displays currency amounts with optional dual-currency display
 */
const CurrencyDisplay = ({
    amount,
    currency = 'USD',
    showBoth = true,
    exchangeRates = null,
    size = 'default',
    color = null,
    style = {}
}) => {
    if (!amount && amount !== 0) {
        return <span style={style}>-</span>;
    }

    const primaryFormatted = formatCurrency(amount, currency);

    if (!showBoth) {
        return (
            <span style={{ fontWeight: size === 'large' ? 'bold' : 'normal', ...style }}>
                {primaryFormatted}
            </span>
        );
    }

    const both = formatBothCurrencies(amount, currency, { exchangeRates });

    const tooltipTitle = `${both.primary} = ${both.secondary}`;

    return (
        <Tooltip title={tooltipTitle}>
            <span style={style}>
                <span style={{ fontWeight: size === 'large' ? 'bold' : 'normal' }}>
                    {both.primary}
                </span>
                <Tag
                    color={color || (currency === 'USD' ? 'green' : 'blue')}
                    style={{ marginLeft: 8, fontSize: size === 'small' ? '11px' : '12px' }}
                >
                    {both.secondary}
                </Tag>
            </span>
        </Tooltip>
    );
};

export default CurrencyDisplay;
